/*
 * Collection Product Image Slider on PDP
 *
 **/

const scrollableDivEl = '.scrollable-div';
const scrollableDivInit = '.scrollable-div--initialized';
const scrollArrowEl = '.scroll-arrow';
const scrollArrowInit = '.scroll-arrow--initialized';
const scrollDisable = 'scroll-disabled';
const scrollParent = '.pdp-collection-carousel';

custom.pdpCollectionCarousel = (function () {
  function scrollHandler() {
    $(scrollableDivEl).each(function () {
      if (!$(this).hasClass(scrollableDivInit)) {
        $(this).addClass(scrollableDivInit);
        $(this).on('scroll', () => {
          let posPercentage =
            ($(this).scrollLeft() / (this.scrollWidth - $(this).width())) * 100;
          $(this)
            .siblings('.fauxUi-track')
            .find('.fauxUi-touch-area')
            .css('left', posPercentage + '%');
          if ($(this).parent().find(scrollArrowEl).hasClass(scrollDisable))
            $(this).parent().find(scrollArrowEl).removeClass(scrollDisable);
          if (posPercentage == 100)
            $(this).parent().find('.scroll-next').addClass(scrollDisable);
          if (posPercentage == 0)
            $(this).parent().find('.scroll-prev').addClass(scrollDisable);
        });
      }
    });
    $(scrollArrowEl).each(function () {
      if (!$(this).hasClass(scrollArrowInit)) {
        $(this).on('click', () => {
          $(this).closest(scrollParent).find(scrollableDivEl).stop();
          if ($(this).hasClass('scroll-next')) {
            $(this)
              .closest(scrollParent)
              .find(scrollableDivEl)
              .animate(
                {
                  scrollLeft:
                    $(this)
                      .closest(scrollParent)
                      .find(scrollableDivEl)
                      .width() +
                    $(this)
                      .closest(scrollParent)
                      .find(scrollableDivEl)
                      .scrollLeft(),
                },
                750,
              );
          } else {
            $(this)
              .closest(scrollParent)
              .find(scrollableDivEl)
              .animate(
                {
                  scrollLeft:
                    $(this)
                      .closest(scrollParent)
                      .find(scrollableDivEl)
                      .scrollLeft() -
                    $(this).closest(scrollParent).find(scrollableDivEl).width(),
                },
                750,
              );
          }
        });
      }
    });
  }

  function init() {
    scrollHandler();
    custom.lazyImages.init();
  }

  return {
    init: init,
  };
})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/pdp-collection-carousel.js